import clsx from 'clsx';

export const SectionProductsLoading = ({ className }: { className?: string }) => {
  return (
    <div className={clsx('grid grid-cols-5 grid-flow-row gap-5', className)}>
      {Array.from({ length: 20 }).map((_, index) => (
        <div key={index} className="h-[390px] w-full bg-slate-200 animate-pulse" />
      ))}
    </div>
  );
};

